import { render } from "./App.vue?vue&type=template&id=4c2f0757"
const script = {}

import exportComponent from "F:\\hwx\\proj\\vscode\\twzc_system_web\\dataV\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__